import { Button, Card, Grid2, MenuItem, TextField } from "@mui/material";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect } from "react";
import { useDocuments } from "../context/DocumentsContext";

export default function FormPage() {
  const {
    listaTipoDocumento,
    formulario,
    setFormulario,
    cargarTipoDocumento,
    limpiar,
    buscar,
  } = useDocuments();

  useEffect(() => {
    cargarTipoDocumento();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card sx={{ p: 2, mb: 1 }} elevation={6}>
        <Grid2 container spacing={1}>
          <Grid2 size={{ md: 3, sm: 4, xs: 12 }}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={dayjs.locale("en")}
            >
              <DesktopDatePicker
                label="Desde"
                format="DD/MM/YYYY"
                value={dayjs(formulario.fechaDesde)}
                onChange={(newDate: Dayjs | null) => {
                  if (newDate) {
                    setFormulario({
                      ...formulario,
                      fechaDesde: newDate.toDate(),
                    });
                  }
                }}
              />
            </LocalizationProvider>
          </Grid2>
          <Grid2 size={{ md: 3, sm: 4, xs: 12 }}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale={dayjs.locale("en")}
            >
              <DesktopDatePicker
                label="Hasta"
                format="DD/MM/YYYY"
                value={dayjs(formulario.fechaHasta)}
                onChange={(newDate: Dayjs | null) => {
                  if (newDate) {
                    setFormulario({
                      ...formulario,
                      fechaHasta: newDate.toDate(),
                    });
                  }
                }}
              />
            </LocalizationProvider>
          </Grid2>
          <Grid2 size={{ md: 3, sm: 4, xs: 12 }}>
            <TextField
              select
              fullWidth
              label="Tipo de documento"
              variant="outlined"
              value={formulario.tipoDocumento}
              onChange={(e) => {
                setFormulario((last) => ({
                  ...last,
                  tipoDocumento: e.target.value,
                }));
              }}
            >
              {listaTipoDocumento.map((tipo) => (
                <MenuItem key={tipo.codigo} value={tipo.codigo}>
                  {tipo.nombre}
                </MenuItem>
              ))}
            </TextField>
          </Grid2>
          <Grid2 size={{ md: 1.2, sm: 2, xs: 6 }}>
            <Button
              fullWidth
              variant="text"
              size="large"
              onClick={() => limpiar()}
              startIcon={<InsertDriveFileRoundedIcon />}
            >
              Nuevo
            </Button>
          </Grid2>
          <Grid2 size={{ md: 1.2, sm: 2, xs: 6 }}>
            <Button
              fullWidth
              variant="text"
              size="large"
              onClick={() => buscar()}
              startIcon={<SearchRoundedIcon />}
            >
              Buscar
            </Button>
          </Grid2>
        </Grid2>
      </Card>
    </>
  );
}
